'use client';

import { CalculatorValues } from './types';

// Components
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import NoticeBubble from '@/components/utils/NoticeBubble';
import { ToolsTranslations } from '@/lib/translations/types';

interface CalculatorCardProps {
  values: CalculatorValues;
  onValuesChange: (field: keyof CalculatorValues, value: number | string) => void;
  finalAmount: number;
  totalReturn: number;
  translations: ToolsTranslations['savings'];
}

export default function CalculatorCard({ 
  values, 
  onValuesChange, 
  finalAmount, 
  totalReturn,
  translations
}: CalculatorCardProps) {
  return (
    <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20">
      <NoticeBubble message={translations.noticeChangeFields} top="-top-1" left="-left-3"  />
      
      {/* Projected Outcome */}
      <ResultsDisplay 
        finalAmount={finalAmount} 
        totalReturn={totalReturn} 
        translations={translations} 
        currency={values.currency}
        onCurrencyChange={(currency) => onValuesChange('currency', currency)}
      />

      {/* Input Sliders */}
      <CalculatorInputs values={values} onValuesChange={onValuesChange} translations={translations} />
    </div>
  );
}
